var map = {
	"./amazon-22px.png": "4863",
	"./apple-22px.png": "bd23",
	"./deezer-22px.png": "7e82",
	"./facebook-22px.png": "9523",
	"./napster-22px.png": "37e0",
	"./pandora-22px.png": "4e3e",
	"./qobuz-22px.png": "08a1",
	"./spotify-22px.png": "b7f0",
	"./tidal-22px.png": "a94e",
	"./youtube-22px.png": "3673",
	"./youtubemusic-22px.png": "93a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7f37";